<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'Direct'">
    <sbnb-direct-subnav></sbnb-direct-subnav>
  </sbnb-subnav>

  <main fxFlex [ngClass.lt-md]="{ mobile: true }" class="subnav__exists">
    <section>
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs>
          <div fxLayout fxLayoutAlign="start center">
            <h2 class="nomargin" fxFlex>Annual Earnings Reports</h2>
          </div>
        </sbnb-page-header>
        <div fxLayout fxLayoutAlign="start center">
          <h2 class="nomargin" fxFlex>Annual Earnings Reports</h2>
        </div>
      </app-feature-flag-tabs>

      <div class="payout-methods-nova">
        <sbnb-helptext-wrapper [area]="'content'" [pageId]="'earnings-reports'"></sbnb-helptext-wrapper>
      </div>
    </section>

    <ng-container *ngIf="payoutMethods?.length === 0">
      <section>
        <sbnb-no-items icon="lock" text="You don't have any Direct payout methods at the moment"></sbnb-no-items>
      </section>
    </ng-container>

    <ng-container *ngIf="payoutMethods?.length > 0">
      <section>
        <div fxLayout fxLayoutAlign="start center">
          <h2 class="nomargin" fxFlex>{{ taxYear }} Reports</h2>
        </div>

        <div class="mt-6">
          <h3 class="nomargin mb-4">All payout methods</h3>

          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px" class="mt-3">
            <sbnb-button type="secondary" size="mini" (clicked)="generateEarningReport('pdf')">
              <sbnb-icon icon="download" class="mr-1"></sbnb-icon>
              Summary (PDF)
            </sbnb-button>
            <sbnb-button type="secondary" size="mini" (clicked)="generateEarningReport('csv')">
              <sbnb-icon icon="download" class="mr-1"></sbnb-icon>
              Details (CSV)
            </sbnb-button>
          </div>
        </div>
      </section>

      <section>
        <div fxLayout fxLayoutAlign="start center" fxLayoutGap="4px" class="mysites-header">
          <h3 class="nomargin" fxFlex>By Payout Method</h3>
        </div>

        <ng-template #loadingPayoutMethodsTemplate>
          <div fxLayout>
            <mat-spinner diameter="24"></mat-spinner>
          </div>
        </ng-template>

        <ng-container *ngIf="loadingPayoutMethods === false; else loadingPayoutMethodsTemplate">
          <div fxLayout fxLayoutGap="32px" fxHide.lt-md class="rules__rule-header">
            <div fxFlex>Payout Method</div>
            <div fxFlex="160px">Summary Report (PDF)</div>
            <div fxFlex="160px">Details Report (CSV)</div>
            <div fxFlex="160px" *ngIf="has1099KForms()">
              <span
                matTooltip="You will receive a 1099-K form if you meet US federal or state requirements for the tax year">
                Form 1099-K
              </span>
            </div>
          </div>

          <div
            *ngFor="let payoutMethod of payoutMethods"
            fxLayout
            fxLayoutGap="32px"
            fxLayoutAlign="start center"
            class="rules__rule-container">
            <span fxFlex class="rule__title">
              {{ payoutMethod.name ?? payoutMethod.derived_name ?? 'Nameless payout method ' + payoutMethod.uuid }}
            </span>

            <div fxFlex="160px">
              <sbnb-button type="secondary" size="mini" (clicked)="generateEarningReport('pdf', payoutMethod.uuid)">
                <sbnb-icon icon="download" class="mr-1"></sbnb-icon>
                Download PDF
              </sbnb-button>
            </div>
            <div fxFlex="160px">
              <sbnb-button type="secondary" size="mini" (clicked)="generateEarningReport('csv', payoutMethod.uuid)">
                <sbnb-icon icon="download" class="mr-1"></sbnb-icon>
                Download CSV
              </sbnb-button>
            </div>
            <div fxFlex="160px" *ngIf="has1099KForms()">
              <sbnb-button
                *ngIf="payoutMethod.forms_1099k?.includes(taxYear)"
                type="secondary"
                size="mini"
                (clicked)="download1099K(payoutMethod.uuid)"
                data-test="download-1099k-button">
                <sbnb-icon icon="download" class="mr-1"></sbnb-icon>
                Download 1099-K
              </sbnb-button>
            </div>
          </div>
        </ng-container>
      </section>
    </ng-container>
    '
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Direct">
  <sbnb-direct-subnav></sbnb-direct-subnav>
</sbnb-mobile-sidebar>
